import { Clock } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo, SaidaPadrao } from './node-chrome';

export default function DelayNode({ data }: any) {
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="delay"
        dados={data}
        icone={Clock}
        corDoTopo="bg-purple-500"
        corDoIcone="text-purple-600"
        titulo={data.label || 'Esperar'}
      />
      <SaidaPadrao />
    </>
  );
}
